{
  "name": "@backbase/ui-ang",
  "version": "14.1.90",
  "description": "Backbase UI Components",
  "peerDependencies": {
    "@angular/animations": "^20 || ^21",
    "@angular/cdk": "^20 || ^21",
    "@angular/core": "^20 || ^21",
    "@angular/common": "^20 || ^21",
    "@angular/forms": "^20 || ^21",
    "@angular/localize": "^20 || ^21",
    "@angular/platform-browser": "^20 || ^21",
    "@angular/router": "^20 || ^21",
    "@ngx-formly/core": "^6.3.12",
    "@ng-bootstrap/ng-bootstrap": "^19 || ^20",
    "@ng-select/ng-select": "^20.0.1 || ^21",
    "@popperjs/core": "^2.11.8",
    "bignumber.js": "^9.0.1",
    "bootstrap": "~5.3.2",
    "ngx-mask": "^20 || ^21",
    "ngx-quill": "^28 || ^29",
    "quill": "^2.0.0",
    "rxjs": ">=7.8.0"
  },
  "dependencies": {
    "@angular/compiler": "^20.1.6",
    "@material/animation": "^14.0.0",
    "@nx/devkit": "^21.3.10",
    "@phenomnomnominal/tsquery": "^6.1.3",
    "libphonenumber-js": "^1.10.48",
    "tslib": "^2.3.0"
  },
  "ng-update": {
    "migrations": "./migrations.json"
  },
  "exports": {
    "./scss/*": {
      "sass": "./scss/*.scss"
    },
    "./assets/*": {
      "default": "./assets/*"
    },
    "./migrations.json": "./migrations.json"
  },
  "backbase": {
    "design-system": "2026.03"
  }
}
